import React, { useState, useEffect } from 'react';
import './SubscriptionManagement.css';

// Modern SVG Icons
const Icons = {
  Subscriptions: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  ),
  Gift: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
    </svg>
  ),
  Tag: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>
    </svg>
  ),
  Mail: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  Refresh: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
    </svg>
  ),
  Zap: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  ),
  Plus: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  ),
  MoreHorizontal: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/>
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  X: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  Users: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  Globe: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  ),
  Ban: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
    </svg>
  ),
  Clock: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  DollarSign: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  ),
  Send: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
    </svg>
  ),
  Copy: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>
  ),
  Edit: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
  ),
  Trash: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    </svg>
  ),
  Link: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
    </svg>
  )
};

const SubscriptionManagement = () => {
  const [activeTab, setActiveTab] = useState('subscriptions'); // subscriptions, promos, nudges, trials
  const [subscriptions, setSubscriptions] = useState([]);
  const [promos, setPromos] = useState([]);
  const [nudgeHistory, setNudgeHistory] = useState([]);
  const [candidates, setCandidates] = useState(null);
  const [stats, setStats] = useState(null);
  const [tiers, setTiers] = useState([]);
  const [merchants, setMerchants] = useState([]); // For single merchant nudge selection
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [merchantSearch, setMerchantSearch] = useState(''); // For searching merchants in nudge form
  const [actionLoading, setActionLoading] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [processingExpired, setProcessingExpired] = useState(false);

  // Trial management state
  const [trials, setTrials] = useState([]);
  const [trialSettings, setTrialSettings] = useState([]);
  const [trialStats, setTrialStats] = useState(null);
  const [trialFilter, setTrialFilter] = useState('all');
  const [trialSearchTerm, setTrialSearchTerm] = useState('');
  const [trialMerchantSearch, setTrialMerchantSearch] = useState('');
  const [searchedMerchants, setSearchedMerchants] = useState([]);

  // Modal states
  const [modal, setModal] = useState({
    isOpen: false,
    type: 'info',
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    details: null
  });

  // Promo form state
  const [promoForm, setPromoForm] = useState({
    isOpen: false,
    editId: null,
    code: '',
    name: '',
    description: '',
    discountType: 'PERCENTAGE',
    discountValue: '',
    maxDiscountAmount: '',
    applicableTiers: [],
    applicablePeriods: [],
    maxUses: '',
    maxUsesPerUser: 1,
    validFrom: '',
    validUntil: '',
    isActive: true,
    // Merchant targeting fields
    targetMerchantIds: [],
    targetCurrentTiers: [],
    isPrivate: false
  });

  // Promo merchant targeting state
  const [promoMerchantSearch, setPromoMerchantSearch] = useState('');
  const [promoSearchedMerchants, setPromoSearchedMerchants] = useState([]);

  // Nudge form state
  const [nudgeForm, setNudgeForm] = useState({
    isOpen: false,
    targetType: 'single', // single, bulk
    userId: '',
    targetGroup: 'expiring_soon',
    nudgeType: 'RENEWAL_REMINDER',
    subject: '',
    message: '',
    includePromoCode: ''
  });

  // Trial form state
  const [trialForm, setTrialForm] = useState({
    isOpen: false,
    userId: '',
    tierName: 'PRO',
    trialDays: 7,
    notes: ''
  });

  // Trial settings form state
  const [trialSettingsForm, setTrialSettingsForm] = useState({
    isOpen: false,
    tierName: '',
    trialDays: 7,
    isEnabled: true,
    requiresCard: false,
    maxTrialsPerUser: 1,
    autoConvert: false
  });

  useEffect(() => {
    fetchData();
  }, [activeTab]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openDropdown && !event.target.closest('.action-dropdown')) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [openDropdown]);

  const fetchData = async () => {
    setLoading(true);
    try {
      if (activeTab === 'subscriptions') {
        await Promise.all([fetchSubscriptions(), fetchTiers(), fetchStats()]);
      } else if (activeTab === 'promos') {
        await fetchPromos();
      } else if (activeTab === 'nudges') {
        await Promise.all([fetchNudgeHistory(), fetchCandidates()]);
      } else if (activeTab === 'trials') {
        await Promise.all([fetchTrials(), fetchTrialSettings(), fetchTrialStats(), fetchTiers()]);
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await fetch('/api/admin/subscription/stats', { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setStats(data.stats);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const fetchTiers = async () => {
    try {
      const response = await fetch('/api/admin/tiers', { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        let tiersData = data.status === 'success' && data.message ? data.message : (Array.isArray(data) ? data : []);
        setTiers(tiersData);
      }
    } catch (error) {
      console.error('Error fetching tiers:', error);
    }
  };

  const fetchSubscriptions = async () => {
    try {
      const response = await fetch('/api/admin/subscriptions', { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        let subscriptionsData = data.success && data.subscriptions ? data.subscriptions : (Array.isArray(data) ? data : []);
        setSubscriptions(subscriptionsData);
      }
    } catch (error) {
      console.error('Error fetching subscriptions:', error);
      setSubscriptions([]);
    }
  };

  const fetchPromos = async () => {
    try {
      const response = await fetch('/api/admin/subscription/promos', { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setPromos(data.promos || []);
      }
    } catch (error) {
      console.error('Error fetching promos:', error);
      setPromos([]);
    }
  };

  const fetchNudgeHistory = async () => {
    try {
      const response = await fetch('/api/admin/subscription/nudges?limit=50', { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setNudgeHistory(data.nudges || []);
      }
    } catch (error) {
      console.error('Error fetching nudge history:', error);
    }
  };

  const fetchCandidates = async () => {
    try {
      const response = await fetch('/api/admin/subscription/candidates', { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setCandidates(data.candidates);
      }
    } catch (error) {
      console.error('Error fetching candidates:', error);
    }
  };

  const fetchMerchants = async (search = '') => {
    try {
      const response = await fetch(`/api/admin/users?role=MERCHANT&limit=50${search ? `&search=${encodeURIComponent(search)}` : ''}`, { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setMerchants(data.users || data || []);
      }
    } catch (error) {
      console.error('Error fetching merchants:', error);
    }
  };

  // Trial management fetch functions
  const fetchTrials = async () => {
    try {
      const statusParam = trialFilter !== 'all' ? `&status=${trialFilter.toUpperCase()}` : '';
      const searchParam = trialSearchTerm ? `&search=${encodeURIComponent(trialSearchTerm)}` : '';
      const response = await fetch(`/api/admin/trials/trials?limit=50${statusParam}${searchParam}`, { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setTrials(data.trials || []);
      }
    } catch (error) {
      console.error('Error fetching trials:', error);
      setTrials([]);
    }
  };

  const fetchTrialSettings = async () => {
    try {
      const response = await fetch('/api/admin/trials/trial-settings', { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setTrialSettings(data.settings || []);
      }
    } catch (error) {
      console.error('Error fetching trial settings:', error);
      setTrialSettings([]);
    }
  };

  const fetchTrialStats = async () => {
    try {
      const response = await fetch('/api/admin/trials/trial-stats', { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setTrialStats(data.stats);
      }
    } catch (error) {
      console.error('Error fetching trial stats:', error);
    }
  };

  const searchMerchantsForTrial = async (search) => {
    if (!search || search.length < 2) {
      setSearchedMerchants([]);
      return;
    }
    try {
      const response = await fetch(`/api/admin/trials/merchants/search?query=${encodeURIComponent(search)}`, { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setSearchedMerchants(data.merchants || []);
      }
    } catch (error) {
      console.error('Error searching merchants:', error);
    }
  };

  const searchMerchantsForPromo = async (search) => {
    if (!search || search.length < 2) {
      setPromoSearchedMerchants([]);
      return;
    }
    try {
      const response = await fetch(`/api/admin/users?role=MERCHANT&limit=20&search=${encodeURIComponent(search)}`, { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        setPromoSearchedMerchants(data.users || data || []);
      }
    } catch (error) {
      console.error('Error searching merchants for promo:', error);
    }
  };

  // Fetch merchants when nudge form opens for single mode
  useEffect(() => {
    if (nudgeForm.isOpen && nudgeForm.targetType === 'single') {
      fetchMerchants(merchantSearch);
    }
  }, [nudgeForm.isOpen, nudgeForm.targetType, merchantSearch]);

  const filteredSubscriptions = subscriptions.filter(sub => {
    const matchesFilter = filter === 'all' || sub.status?.toLowerCase() === filter.toLowerCase();
    const matchesSearch = !searchTerm ||
      sub.user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      sub.user?.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      sub.id.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const showModal = (type, title, message, onConfirm = null, details = null) => {
    setModal({ isOpen: true, type, title, message, onConfirm, onCancel: () => setModal(prev => ({ ...prev, isOpen: false })), details });
  };

  const closeModal = () => setModal(prev => ({ ...prev, isOpen: false }));

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const formatCurrency = (amount, currency = 'NGN') => {
    return new Intl.NumberFormat('en-NG', { style: 'currency', currency }).format(amount || 0);
  };

  // ============================================
  // SUBSCRIPTION HANDLERS
  // ============================================

  const handleProcessExpired = async () => {
    const processAction = async () => {
      closeModal();
      try {
        setProcessingExpired(true);
        const response = await fetch('/api/admin/subscription/process-expired', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            revokeTeamAccess: true,
            customDomainGraceDays: 7,
            sendNotifications: true
          })
        });
        const data = await response.json();
        if (response.ok && data.success) {
          showModal('success', 'Processing Complete',
            `Processed ${data.stats?.merchantsProcessed || 0} expired subscription(s)\n` +
            `Team members revoked: ${data.stats?.teamMembersRevoked || 0}\n` +
            `Custom domains in grace period: ${data.stats?.customDomainsScheduled || 0}`
          );
          fetchData();
        } else {
          showModal('error', 'Processing Failed', data.error || 'Unknown error');
        }
      } catch (error) {
        showModal('error', 'Processing Failed', error.message);
      } finally {
        setProcessingExpired(false);
      }
    };

    showModal('confirm', 'Process Expired Subscriptions',
      'This will:\n• Downgrade expired subscriptions to FREE\n• Revoke team member access\n• Set custom domains to 7-day grace period\n• Send expiration emails',
      processAction
    );
  };

  const handleActivateSubscription = async (subscription) => {
    setOpenDropdown(null);
    const activateAction = async () => {
      closeModal();
      try {
        setActionLoading(subscription.id);
        const response = await fetch(`/api/admin/subscriptions/${subscription.id}/update-status`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ status: 'ACTIVE', paymentStatus: 'PAID' })
        });
        const data = await response.json();
        if (response.ok && data.success) {
          showModal('success', 'Success', 'Subscription activated!');
          fetchSubscriptions();
        } else {
          showModal('error', 'Failed', data.error);
        }
      } catch (error) {
        showModal('error', 'Failed', error.message);
      } finally {
        setActionLoading(null);
      }
    };
    showModal('confirm', 'Activate Subscription', 'Activate this subscription?', activateAction);
  };

  const handleCancelSubscription = async (subscriptionId) => {
    setOpenDropdown(null);
    const cancelAction = async () => {
      closeModal();
      try {
        setActionLoading(subscriptionId);
        const response = await fetch(`/api/admin/subscriptions/${subscriptionId}/update-status`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ status: 'CANCELLED' })
        });
        const data = await response.json();
        if (response.ok && data.success) {
          showModal('success', 'Cancelled', 'Subscription cancelled!');
          fetchSubscriptions();
        } else {
          showModal('error', 'Failed', data.error);
        }
      } catch (error) {
        showModal('error', 'Failed', error.message);
      } finally {
        setActionLoading(null);
      }
    };
    showModal('warning', 'Cancel Subscription', 'This cannot be undone. Continue?', cancelAction);
  };

  const handleRevokeTeamAccess = async (merchantId, email) => {
    setOpenDropdown(null);
    const revokeAction = async () => {
      closeModal();
      try {
        setActionLoading(merchantId);
        const response = await fetch(`/api/admin/subscription/revoke-team-access/${merchantId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include'
        });
        const data = await response.json();
        if (response.ok && data.success) {
          showModal('success', 'Team Access Revoked', data.message);
        } else {
          showModal('error', 'Failed', data.error || 'Could not revoke team access');
        }
      } catch (error) {
        showModal('error', 'Failed', error.message);
      } finally {
        setActionLoading(null);
      }
    };
    showModal('warning', 'Revoke Team Access', `Suspend all team members for ${email}?`, revokeAction);
  };

  const handleManageDomains = async (merchantId, email, action = 'grace_period') => {
    setOpenDropdown(null);
    const manageAction = async () => {
      closeModal();
      try {
        setActionLoading(merchantId);
        const response = await fetch(`/api/admin/subscription/suspend-domains/${merchantId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ action, graceDays: 7 })
        });
        const data = await response.json();
        if (response.ok && data.success) {
          showModal('success', action === 'suspend' ? 'Domains Suspended' : 'Grace Period Set', data.message);
        } else {
          showModal('error', 'Failed', data.error || 'Could not manage domains');
        }
      } catch (error) {
        showModal('error', 'Failed', error.message);
      } finally {
        setActionLoading(null);
      }
    };
    const actionText = action === 'suspend' ? 'immediately suspend' : 'set a 7-day grace period for';
    showModal('warning', 'Manage Custom Domains', `${actionText} all custom domains for ${email}?`, manageAction);
  };

  // ============================================
  // PROMO HANDLERS
  // ============================================

  const openPromoForm = (promo = null) => {
    setPromoMerchantSearch('');
    setPromoSearchedMerchants([]);
    if (promo) {
      setPromoForm({
        isOpen: true,
        editId: promo.id,
        code: promo.code,
        name: promo.name,
        description: promo.description || '',
        discountType: promo.discountType,
        discountValue: promo.discountValue,
        maxDiscountAmount: promo.maxDiscountAmount || '',
        applicableTiers: promo.applicableTiers || [],
        applicablePeriods: promo.applicablePeriods || [],
        maxUses: promo.maxUses || '',
        maxUsesPerUser: promo.maxUsesPerUser || 1,
        validFrom: promo.validFrom ? new Date(promo.validFrom).toISOString().split('T')[0] : '',
        validUntil: promo.validUntil ? new Date(promo.validUntil).toISOString().split('T')[0] : '',
        isActive: promo.isActive,
        // Merchant targeting fields
        targetMerchantIds: promo.targetMerchantIds || [],
        targetCurrentTiers: promo.targetCurrentTiers || [],
        isPrivate: promo.isPrivate || false
      });
    } else {
      setPromoForm({
        isOpen: true,
        editId: null,
        code: '',
        name: '',
        description: '',
        discountType: 'PERCENTAGE',
        discountValue: '',
        maxDiscountAmount: '',
        applicableTiers: [],
        applicablePeriods: [],
        maxUses: '',
        maxUsesPerUser: 1,
        validFrom: new Date().toISOString().split('T')[0],
        validUntil: '',
        isActive: true,
        // Merchant targeting fields
        targetMerchantIds: [],
        targetCurrentTiers: [],
        isPrivate: false
      });
    }
  };

  const handleSavePromo = async () => {
    try {
      setActionLoading('promo');
      const url = promoForm.editId
        ? `/api/admin/subscription/promos/${promoForm.editId}`
        : '/api/admin/subscription/promos';

      const response = await fetch(url, {
        method: promoForm.editId ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          code: promoForm.code,
          name: promoForm.name,
          description: promoForm.description,
          discountType: promoForm.discountType,
          discountValue: parseFloat(promoForm.discountValue),
          maxDiscountAmount: promoForm.maxDiscountAmount ? parseFloat(promoForm.maxDiscountAmount) : null,
          applicableTiers: promoForm.applicableTiers,
          applicablePeriods: promoForm.applicablePeriods,
          maxUses: promoForm.maxUses ? parseInt(promoForm.maxUses) : null,
          maxUsesPerUser: parseInt(promoForm.maxUsesPerUser),
          validFrom: promoForm.validFrom,
          validUntil: promoForm.validUntil || null,
          isActive: promoForm.isActive,
          // Merchant targeting fields
          targetMerchantIds: promoForm.targetMerchantIds,
          targetCurrentTiers: promoForm.targetCurrentTiers,
          isPrivate: promoForm.isPrivate
        })
      });

      const data = await response.json();
      if (response.ok && data.success) {
        showModal('success', 'Success', `Promo code ${promoForm.editId ? 'updated' : 'created'}!`);
        setPromoForm(prev => ({ ...prev, isOpen: false }));
        fetchPromos();
      } else {
        showModal('error', 'Failed', data.error);
      }
    } catch (error) {
      showModal('error', 'Failed', error.message);
    } finally {
      setActionLoading(null);
    }
  };

  const handleDeletePromo = async (promoId) => {
    const deleteAction = async () => {
      closeModal();
      try {
        const response = await fetch(`/api/admin/subscription/promos/${promoId}`, {
          method: 'DELETE',
          credentials: 'include'
        });
        const data = await response.json();
        if (response.ok && data.success) {
          showModal('success', 'Deleted', 'Promo code deactivated');
          fetchPromos();
        } else {
          showModal('error', 'Failed', data.error);
        }
      } catch (error) {
        showModal('error', 'Failed', error.message);
      }
    };
    showModal('warning', 'Delete Promo', 'Deactivate this promo code?', deleteAction);
  };

  // ============================================
  // NUDGE HANDLERS
  // ============================================

  const handleSendNudge = async () => {
    try {
      setActionLoading('nudge');
      const url = nudgeForm.targetType === 'bulk'
        ? '/api/admin/subscription/nudge/bulk'
        : '/api/admin/subscription/nudge';

      const body = nudgeForm.targetType === 'bulk'
        ? {
            targetGroup: nudgeForm.targetGroup,
            nudgeType: nudgeForm.nudgeType,
            subject: nudgeForm.subject,
            message: nudgeForm.message,
            includePromoCode: nudgeForm.includePromoCode || undefined
          }
        : {
            userId: nudgeForm.userId,
            nudgeType: nudgeForm.nudgeType,
            subject: nudgeForm.subject,
            message: nudgeForm.message,
            includePromoCode: nudgeForm.includePromoCode || undefined
          };

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body)
      });

      const data = await response.json();
      if (response.ok && data.success) {
        showModal('success', 'Sent!', data.message);
        setNudgeForm(prev => ({ ...prev, isOpen: false }));
        fetchNudgeHistory();
      } else {
        showModal('error', 'Failed', data.error);
      }
    } catch (error) {
      showModal('error', 'Failed', error.message);
    } finally {
      setActionLoading(null);
    }
  };

  // ============================================
  // TRIAL HANDLERS
  // ============================================

  const handleAddTrial = async () => {
    if (!trialForm.userId || !trialForm.tierName) {
      showModal('error', 'Missing Info', 'Please select a merchant and tier');
      return;
    }
    try {
      setActionLoading('trial');
      const response = await fetch('/api/admin/trials/trials', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          userId: trialForm.userId,
          tierName: trialForm.tierName,
          trialDays: parseInt(trialForm.trialDays) || 7,
          notes: trialForm.notes
        })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        showModal('success', 'Trial Added', data.message);
        setTrialForm(prev => ({ ...prev, isOpen: false, userId: '', notes: '' }));
        setSearchedMerchants([]);
        setTrialMerchantSearch('');
        fetchData();
      } else {
        showModal('error', 'Failed', data.error);
      }
    } catch (error) {
      showModal('error', 'Failed', error.message);
    } finally {
      setActionLoading(null);
    }
  };

  const handleCancelTrial = async (trialId, email) => {
    const cancelAction = async () => {
      closeModal();
      try {
        setActionLoading(trialId);
        const response = await fetch(`/api/admin/trials/trials/${trialId}`, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ reason: 'Cancelled by admin' })
        });
        const data = await response.json();
        if (response.ok && data.success) {
          showModal('success', 'Trial Cancelled', data.message);
          fetchData();
        } else {
          showModal('error', 'Failed', data.error);
        }
      } catch (error) {
        showModal('error', 'Failed', error.message);
      } finally {
        setActionLoading(null);
      }
    };
    showModal('warning', 'Cancel Trial', `Cancel trial for ${email}? User will be downgraded to FREE.`, cancelAction);
  };

  const handleExtendTrial = async (trialId, email) => {
    const days = prompt('How many days to extend?', '7');
    if (!days || isNaN(parseInt(days))) return;

    try {
      setActionLoading(trialId);
      const response = await fetch(`/api/admin/trials/trials/${trialId}/extend`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ additionalDays: parseInt(days), notes: 'Extended by admin' })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        showModal('success', 'Trial Extended', data.message);
        fetchData();
      } else {
        showModal('error', 'Failed', data.error);
      }
    } catch (error) {
      showModal('error', 'Failed', error.message);
    } finally {
      setActionLoading(null);
    }
  };

  const handleConvertTrial = async (trialId, email) => {
    const convertAction = async () => {
      closeModal();
      try {
        setActionLoading(trialId);
        const response = await fetch(`/api/admin/trials/trials/${trialId}/convert`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ period: 'MONTHLY', notes: 'Converted by admin' })
        });
        const data = await response.json();
        if (response.ok && data.success) {
          showModal('success', 'Trial Converted', data.message);
          fetchData();
        } else {
          showModal('error', 'Failed', data.error);
        }
      } catch (error) {
        showModal('error', 'Failed', error.message);
      } finally {
        setActionLoading(null);
      }
    };
    showModal('confirm', 'Convert to Paid', `Convert ${email}'s trial to paid subscription?`, convertAction);
  };

  const handleSaveTrialSettings = async () => {
    try {
      setActionLoading('trialSettings');
      const response = await fetch('/api/admin/trials/trial-settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          tierName: trialSettingsForm.tierName,
          trialDays: parseInt(trialSettingsForm.trialDays) || 7,
          isEnabled: trialSettingsForm.isEnabled,
          requiresCard: trialSettingsForm.requiresCard,
          maxTrialsPerUser: parseInt(trialSettingsForm.maxTrialsPerUser) || 1,
          autoConvert: trialSettingsForm.autoConvert
        })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        showModal('success', 'Settings Saved', 'Trial settings updated successfully');
        setTrialSettingsForm(prev => ({ ...prev, isOpen: false }));
        fetchTrialSettings();
      } else {
        showModal('error', 'Failed', data.error);
      }
    } catch (error) {
      showModal('error', 'Failed', error.message);
    } finally {
      setActionLoading(null);
    }
  };

  const handleProcessExpiredTrials = async () => {
    const processAction = async () => {
      closeModal();
      try {
        setActionLoading('processTrials');
        const response = await fetch('/api/admin/trials/process-expired-trials', {
          method: 'POST',
          credentials: 'include'
        });
        const data = await response.json();
        if (response.ok && data.success) {
          showModal('success', 'Processed', data.message);
          fetchData();
        } else {
          showModal('error', 'Failed', data.error);
        }
      } catch (error) {
        showModal('error', 'Failed', error.message);
      } finally {
        setActionLoading(null);
      }
    };
    showModal('confirm', 'Process Expired Trials', 'This will downgrade all expired trials to FREE tier.', processAction);
  };

  const openTrialSettingsForm = (setting = null) => {
    if (setting) {
      setTrialSettingsForm({
        isOpen: true,
        tierName: setting.tierName,
        trialDays: setting.trialDays,
        isEnabled: setting.isEnabled,
        requiresCard: setting.requiresCard,
        maxTrialsPerUser: setting.maxTrialsPerUser,
        autoConvert: setting.autoConvert
      });
    } else {
      setTrialSettingsForm({
        isOpen: true,
        tierName: '',
        trialDays: 7,
        isEnabled: true,
        requiresCard: false,
        maxTrialsPerUser: 1,
        autoConvert: false
      });
    }
  };

  // ============================================
  // RENDER HELPERS
  // ============================================

  const getStatusBadge = (status) => {
    const classes = {
      ACTIVE: 'status-active',
      PENDING: 'status-pending',
      EXPIRED: 'status-expired',
      CANCELLED: 'status-cancelled'
    };
    return <span className={`status-badge ${classes[status] || ''}`}>{status}</span>;
  };

  const renderSubscriptionsTab = () => (
    <>
      {stats && (
        <div className="stats">
          <div className="stat-card">
            <div className="stat-label">Total Merchants</div>
            <div className="stat-value">{stats.merchants?.total || 0}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">FREE</div>
            <div className="stat-value">{stats.merchants?.free || 0}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">PRO</div>
            <div className="stat-value">{stats.merchants?.pro || 0}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">PREMIUM</div>
            <div className="stat-value">{stats.merchants?.premium || 0}</div>
          </div>
          <div className="stat-card highlight">
            <div className="stat-label">Expiring Soon</div>
            <div className="stat-value">{stats.subscriptions?.expiringWithin7Days || 0}</div>
          </div>
          <div className="stat-card warning">
            <div className="stat-label">Recently Expired</div>
            <div className="stat-value">{stats.subscriptions?.recentlyExpired || 0}</div>
          </div>
        </div>
      )}

      <div className="controls">
        <input
          type="text"
          placeholder="Search by email, username, or ID..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <div className="filter-buttons">
          {['all', 'active', 'pending', 'expired'].map(f => (
            <button key={f} className={filter === f ? 'active' : ''} onClick={() => setFilter(f)}>
              {f.charAt(0).toUpperCase() + f.slice(1)} ({subscriptions.filter(s => f === 'all' || s.status?.toLowerCase() === f).length})
            </button>
          ))}
        </div>
      </div>

      <div className="subscriptions-table">
        {filteredSubscriptions.length === 0 ? (
          <div className="no-data">No subscriptions found</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Tier</th>
                <th>Period</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredSubscriptions.map(sub => (
                <tr key={sub.id}>
                  <td>
                    <div className="user-cell">
                      <div className="user-name">{sub.user?.username || 'Unknown'}</div>
                      <div className="user-email">{sub.user?.email || 'N/A'}</div>
                    </div>
                  </td>
                  <td><span className={`tier-badge tier-${sub.tier?.toLowerCase()}`}>{sub.tier}</span></td>
                  <td>{sub.period}</td>
                  <td>{formatCurrency(sub.amount, sub.currency)}</td>
                  <td>{getStatusBadge(sub.status)}</td>
                  <td>{formatDate(sub.startDate)}</td>
                  <td>{formatDate(sub.endDate)}</td>
                  <td>
                    <div className="action-dropdown">
                      <button className="dropdown-trigger" onClick={() => setOpenDropdown(openDropdown === sub.id ? null : sub.id)} disabled={actionLoading === sub.id}>
                        {actionLoading === sub.id ? '...' : <Icons.MoreHorizontal />}
                      </button>
                      {openDropdown === sub.id && (
                        <div className="dropdown-menu">
                          {sub.status === 'PENDING' && (
                            <button className="dropdown-item activate" onClick={() => handleActivateSubscription(sub)}><Icons.Check /> Activate</button>
                          )}
                          <button className="dropdown-item" onClick={() => {
                            setNudgeForm(prev => ({ ...prev, isOpen: true, targetType: 'single', userId: sub.userId }));
                            setOpenDropdown(null);
                          }}><Icons.Mail /> Send Nudge</button>
                          <button className="dropdown-item" onClick={() => handleRevokeTeamAccess(sub.userId, sub.user?.email)}>
                            <Icons.Users /> Revoke Team Access
                          </button>
                          <button className="dropdown-item" onClick={() => handleManageDomains(sub.userId, sub.user?.email, 'grace_period')}>
                            <Icons.Clock /> Set Domain Grace Period
                          </button>
                          <button className="dropdown-item" onClick={() => handleManageDomains(sub.userId, sub.user?.email, 'suspend')}>
                            <Icons.Ban /> Suspend Domains
                          </button>
                          {sub.status !== 'CANCELLED' && (
                            <button className="dropdown-item cancel" onClick={() => handleCancelSubscription(sub.id)}><Icons.X /> Cancel</button>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );

  const renderPromosTab = () => (
    <>
      <div className="section-header">
        <h3>Promo Codes</h3>
        <button className="primary-btn" onClick={() => openPromoForm()}>+ Create Promo</button>
      </div>

      <div className="promos-grid">
        {promos.length === 0 ? (
          <div className="no-data">No promo codes yet</div>
        ) : (
          promos.map(promo => (
            <div key={promo.id} className={`promo-card ${!promo.isActive || promo.isExpired ? 'inactive' : ''}`}>
              <div className="promo-header">
                <code className="promo-code">{promo.code}</code>
                <span className={`promo-status ${promo.isActive && !promo.isExpired ? 'active' : 'inactive'}`}>
                  {promo.isExpired ? 'Expired' : promo.isFullyUsed ? 'Fully Used' : promo.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
              <h4>{promo.name}</h4>
              <p className="promo-discount">
                {promo.discountType === 'PERCENTAGE' ? `${promo.discountValue}% off` : `₦${promo.discountValue} off`}
                {promo.maxDiscountAmount && ` (max ₦${promo.maxDiscountAmount})`}
              </p>
              <div className="promo-meta">
                <span>Used: {promo.usedCount}/{promo.maxUses || '∞'}</span>
                {promo.validUntil && <span>Expires: {formatDate(promo.validUntil)}</span>}
              </div>
              {/* Targeting info */}
              <div className="promo-targeting">
                {promo.isPrivate && <span className="targeting-badge private">Private</span>}
                {promo.targetCurrentTiers?.length > 0 && (
                  <span className="targeting-badge tiers">
                    For: {promo.targetCurrentTiers.join(', ')}
                  </span>
                )}
                {promo.targetMerchantIds?.length > 0 && (
                  <span className="targeting-badge merchants">
                    {promo.targetMerchantIds.length} specific merchant(s)
                  </span>
                )}
              </div>
              <div className="promo-actions">
                <button className="btn-sm" onClick={() => openPromoForm(promo)}>Edit</button>
                {promo.isPrivate && promo.code && (
                  <button
                    className="btn-sm"
                    onClick={() => {
                      navigator.clipboard.writeText(`https://app.userevstar.com/offer?code=${promo.code}`);
                      showModal('success', 'Copied!', 'Offer link copied to clipboard');
                    }}
                  >
                    Copy Link
                  </button>
                )}
                <button className="btn-sm danger" onClick={() => handleDeletePromo(promo.id)}>Delete</button>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );

  const renderNudgesTab = () => (
    <>
      <div className="section-header">
        <h3>Merchant Nudges</h3>
        <button className="primary-btn" onClick={() => setNudgeForm(prev => ({ ...prev, isOpen: true, targetType: 'bulk' }))}>
          <Icons.Send /> Send Bulk Nudge
        </button>
      </div>

      {candidates && (
        <div className="candidates-grid">
          <div className="candidate-card" onClick={() => setNudgeForm(prev => ({ ...prev, isOpen: true, targetType: 'bulk', targetGroup: 'expiring_soon' }))}>
            <div className="candidate-count">{candidates.expiringSoon}</div>
            <div className="candidate-label">Expiring Soon</div>
          </div>
          <div className="candidate-card" onClick={() => setNudgeForm(prev => ({ ...prev, isOpen: true, targetType: 'bulk', targetGroup: 'expired' }))}>
            <div className="candidate-count">{candidates.expired}</div>
            <div className="candidate-label">Recently Expired</div>
          </div>
          <div className="candidate-card" onClick={() => setNudgeForm(prev => ({ ...prev, isOpen: true, targetType: 'bulk', targetGroup: 'free_tier' }))}>
            <div className="candidate-count">{candidates.freeTier}</div>
            <div className="candidate-label">Free Tier</div>
          </div>
          <div className="candidate-card" onClick={() => setNudgeForm(prev => ({ ...prev, isOpen: true, targetType: 'bulk', targetGroup: 'inactive' }))}>
            <div className="candidate-count">{candidates.inactive}</div>
            <div className="candidate-label">Inactive (30d)</div>
          </div>
        </div>
      )}

      <h4 style={{ marginTop: 24 }}>Recent Nudges</h4>
      <div className="nudge-history">
        {nudgeHistory.length === 0 ? (
          <div className="no-data">No nudges sent yet</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Merchant</th>
                <th>Type</th>
                <th>Subject</th>
                <th>Sent At</th>
                <th>Action Taken</th>
              </tr>
            </thead>
            <tbody>
              {nudgeHistory.map(nudge => (
                <tr key={nudge.id}>
                  <td>{nudge.user?.email || 'Unknown'}</td>
                  <td><span className="nudge-type">{nudge.nudgeType?.replace(/_/g, ' ')}</span></td>
                  <td>{nudge.subject}</td>
                  <td>{formatDate(nudge.sentAt)}</td>
                  <td>{nudge.actionTaken ? <span style={{ color: '#059669', fontWeight: 500 }}>Yes</span> : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );

  const renderTrialsTab = () => (
    <>
      {/* Trial Stats */}
      {trialStats && (
        <div className="stats">
          <div className="stat-card">
            <div className="stat-label">Active Trials</div>
            <div className="stat-value">{trialStats.activeTrials}</div>
          </div>
          <div className="stat-card highlight">
            <div className="stat-label">Expiring Soon</div>
            <div className="stat-value">{trialStats.expiringSoon}</div>
          </div>
          <div className="stat-card" style={{ background: '#e8f5e9' }}>
            <div className="stat-label">Converted</div>
            <div className="stat-value">{trialStats.convertedTrials}</div>
          </div>
          <div className="stat-card warning">
            <div className="stat-label">Expired</div>
            <div className="stat-value">{trialStats.expiredTrials}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Conversion Rate</div>
            <div className="stat-value">{trialStats.conversionRate}</div>
          </div>
        </div>
      )}

      {/* Trial Settings Section */}
      <div className="section-header" style={{ marginTop: 24 }}>
        <h3>Trial Settings by Tier</h3>
        <button className="primary-btn" onClick={() => openTrialSettingsForm()}>+ Add Trial Setting</button>
      </div>

      <div className="promos-grid" style={{ marginBottom: 24 }}>
        {trialSettings.length === 0 ? (
          <div className="no-data">No trial settings configured. Add settings for each tier you want to offer trials.</div>
        ) : (
          trialSettings.map(setting => (
            <div key={setting.id} className={`promo-card ${!setting.isEnabled ? 'inactive' : ''}`}>
              <div className="promo-header">
                <span className={`tier-badge tier-${setting.tierName?.toLowerCase()}`}>{setting.tierName}</span>
                <span className={`promo-status ${setting.isEnabled ? 'active' : 'inactive'}`}>
                  {setting.isEnabled ? 'Enabled' : 'Disabled'}
                </span>
              </div>
              <h4>{setting.tierDisplayName || setting.tierName} Trial</h4>
              <div className="promo-meta">
                <span><strong>{setting.trialDays}</strong> days trial</span>
                <span>Max {setting.maxTrialsPerUser} trial(s)/user</span>
              </div>
              <div className="promo-meta">
                {setting.requiresCard && <span>Requires Card</span>}
                {setting.autoConvert && <span>Auto-convert</span>}
              </div>
              <div className="promo-actions">
                <button className="btn-sm" onClick={() => openTrialSettingsForm(setting)}>Edit</button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Active Trials Section */}
      <div className="section-header">
        <h3>Merchant Trials</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="primary-btn" onClick={() => setTrialForm(prev => ({ ...prev, isOpen: true }))}>
            + Add Merchant to Trial
          </button>
          <button
            className="process-expired-btn"
            onClick={handleProcessExpiredTrials}
            disabled={actionLoading === 'processTrials'}
          >
            <Icons.Zap /> {actionLoading === 'processTrials' ? 'Processing...' : 'Process Expired'}
          </button>
        </div>
      </div>

      <div className="controls">
        <input
          type="text"
          placeholder="Search by email..."
          value={trialSearchTerm}
          onChange={(e) => {
            setTrialSearchTerm(e.target.value);
            // Debounced search would be better, but for now just search on blur
          }}
          onBlur={() => fetchTrials()}
          className="search-input"
        />
        <div className="filter-buttons">
          {['all', 'active', 'converted', 'expired', 'cancelled'].map(f => (
            <button
              key={f}
              className={trialFilter === f ? 'active' : ''}
              onClick={() => { setTrialFilter(f); setTimeout(fetchTrials, 100); }}
            >
              {f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="subscriptions-table">
        {trials.length === 0 ? (
          <div className="no-data">No trials found</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Merchant</th>
                <th>Store</th>
                <th>Tier</th>
                <th>Status</th>
                <th>Started</th>
                <th>Ends</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {trials.map(trial => (
                <tr key={trial.id}>
                  <td>
                    <div className="user-cell">
                      <div className="user-name">{trial.user?.username || 'Unknown'}</div>
                      <div className="user-email">{trial.user?.email || 'N/A'}</div>
                    </div>
                  </td>
                  <td>{trial.user?.store?.name || 'No store'}</td>
                  <td><span className={`tier-badge tier-${trial.tierName?.toLowerCase()}`}>{trial.tierName}</span></td>
                  <td>{getStatusBadge(trial.status)}</td>
                  <td>{formatDate(trial.startedAt)}</td>
                  <td>{formatDate(trial.endsAt)}</td>
                  <td>
                    {trial.status === 'ACTIVE' && (
                      <div className="action-dropdown">
                        <button
                          className="dropdown-trigger"
                          onClick={() => setOpenDropdown(openDropdown === `trial-${trial.id}` ? null : `trial-${trial.id}`)}
                          disabled={actionLoading === trial.id}
                        >
                          {actionLoading === trial.id ? '...' : <Icons.MoreHorizontal />}
                        </button>
                        {openDropdown === `trial-${trial.id}` && (
                          <div className="dropdown-menu">
                            <button className="dropdown-item" onClick={() => { handleExtendTrial(trial.id, trial.user?.email); setOpenDropdown(null); }}>
                              <Icons.Clock /> Extend Trial
                            </button>
                            <button className="dropdown-item activate" onClick={() => { handleConvertTrial(trial.id, trial.user?.email); setOpenDropdown(null); }}>
                              <Icons.DollarSign /> Convert to Paid
                            </button>
                            <button className="dropdown-item cancel" onClick={() => { handleCancelTrial(trial.id, trial.user?.email); setOpenDropdown(null); }}>
                              <Icons.X /> Cancel Trial
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    {trial.status !== 'ACTIVE' && <span className="text-muted">—</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );

  if (loading && activeTab === 'subscriptions') {
    return (
      <div className="subscription-management">
        <h2>Subscription Management</h2>
        <div className="loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="subscription-management">
      <div className="header">
        <h2>Subscription Management</h2>
        <div className="header-actions">
          <button onClick={handleProcessExpired} className="process-expired-btn" disabled={processingExpired}>
            <Icons.Zap /> {processingExpired ? 'Processing...' : 'Process Expired'}
          </button>
          <button onClick={fetchData} className="refresh-btn">
            <Icons.Refresh /> Refresh
          </button>
        </div>
      </div>

      <div className="tabs">
        <button className={activeTab === 'subscriptions' ? 'active' : ''} onClick={() => setActiveTab('subscriptions')}>
          <Icons.Subscriptions /> Subscriptions
        </button>
        <button className={activeTab === 'trials' ? 'active' : ''} onClick={() => setActiveTab('trials')}>
          <Icons.Gift /> Free Trials
        </button>
        <button className={activeTab === 'promos' ? 'active' : ''} onClick={() => setActiveTab('promos')}>
          <Icons.Tag /> Promos
        </button>
        <button className={activeTab === 'nudges' ? 'active' : ''} onClick={() => setActiveTab('nudges')}>
          <Icons.Mail /> Nudges
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'subscriptions' && renderSubscriptionsTab()}
        {activeTab === 'trials' && renderTrialsTab()}
        {activeTab === 'promos' && renderPromosTab()}
        {activeTab === 'nudges' && renderNudgesTab()}
      </div>

      {/* Promo Form Modal */}
      {promoForm.isOpen && (
        <div className="modal-overlay" onClick={() => setPromoForm(prev => ({ ...prev, isOpen: false }))}>
          <div className="modal-content modal-form" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{promoForm.editId ? 'Edit Promo Code' : 'Create Promo Code'}</h3>
              <button className="modal-close" onClick={() => setPromoForm(prev => ({ ...prev, isOpen: false }))}><Icons.X /></button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <label>Code *</label>
                <input type="text" value={promoForm.code} onChange={e => setPromoForm(prev => ({ ...prev, code: e.target.value.toUpperCase() }))} placeholder="e.g., NEWYEAR50" />
              </div>
              <div className="form-row">
                <label>Name *</label>
                <input type="text" value={promoForm.name} onChange={e => setPromoForm(prev => ({ ...prev, name: e.target.value }))} placeholder="New Year Special" />
              </div>
              <div className="form-row">
                <label>Description</label>
                <textarea value={promoForm.description} onChange={e => setPromoForm(prev => ({ ...prev, description: e.target.value }))} placeholder="Internal notes..." />
              </div>
              <div className="form-row-inline">
                <div>
                  <label>Discount Type</label>
                  <select value={promoForm.discountType} onChange={e => setPromoForm(prev => ({ ...prev, discountType: e.target.value }))}>
                    <option value="PERCENTAGE">Percentage</option>
                    <option value="FIXED_AMOUNT">Fixed Amount</option>
                  </select>
                </div>
                <div>
                  <label>Discount Value *</label>
                  <input type="number" value={promoForm.discountValue} onChange={e => setPromoForm(prev => ({ ...prev, discountValue: e.target.value }))} placeholder={promoForm.discountType === 'PERCENTAGE' ? '10' : '5000'} />
                </div>
              </div>
              {promoForm.discountType === 'PERCENTAGE' && (
                <div className="form-row">
                  <label>Max Discount Amount (₦)</label>
                  <input type="number" value={promoForm.maxDiscountAmount} onChange={e => setPromoForm(prev => ({ ...prev, maxDiscountAmount: e.target.value }))} placeholder="Optional cap" />
                </div>
              )}
              <div className="form-row-inline">
                <div>
                  <label>Max Total Uses</label>
                  <input type="number" value={promoForm.maxUses} onChange={e => setPromoForm(prev => ({ ...prev, maxUses: e.target.value }))} placeholder="Unlimited" />
                </div>
                <div>
                  <label>Max Uses Per User</label>
                  <input type="number" value={promoForm.maxUsesPerUser} onChange={e => setPromoForm(prev => ({ ...prev, maxUsesPerUser: e.target.value }))} />
                </div>
              </div>
              <div className="form-row-inline">
                <div>
                  <label>Valid From</label>
                  <input type="date" value={promoForm.validFrom} onChange={e => setPromoForm(prev => ({ ...prev, validFrom: e.target.value }))} />
                </div>
                <div>
                  <label>Valid Until</label>
                  <input type="date" value={promoForm.validUntil} onChange={e => setPromoForm(prev => ({ ...prev, validUntil: e.target.value }))} />
                </div>
              </div>
              <div className="form-row">
                <label className="checkbox-label">
                  <input type="checkbox" checked={promoForm.isActive} onChange={e => setPromoForm(prev => ({ ...prev, isActive: e.target.checked }))} />
                  Active
                </label>
              </div>

              {/* Merchant Targeting Section */}
              <div className="form-section-divider">
                <span>Merchant Targeting (Optional)</span>
              </div>

              <div className="form-row">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={promoForm.isPrivate}
                    onChange={e => setPromoForm(prev => ({ ...prev, isPrivate: e.target.checked }))}
                  />
                  Private Promo (only accessible via direct link)
                </label>
              </div>

              <div className="form-row">
                <label>Target Current Tiers</label>
                <div className="checkbox-group">
                  {['FREE', 'TRIAL'].map(tier => (
                    <label key={tier} className="checkbox-label inline">
                      <input
                        type="checkbox"
                        checked={promoForm.targetCurrentTiers.includes(tier)}
                        onChange={e => {
                          const newTiers = e.target.checked
                            ? [...promoForm.targetCurrentTiers, tier]
                            : promoForm.targetCurrentTiers.filter(t => t !== tier);
                          setPromoForm(prev => ({ ...prev, targetCurrentTiers: newTiers }));
                        }}
                      />
                      {tier}
                    </label>
                  ))}
                </div>
                <small className="form-hint">Leave empty to allow any tier. Select tiers to restrict who can use this promo.</small>
              </div>

              <div className="form-row">
                <label>Target Specific Merchants</label>
                <input
                  type="text"
                  value={promoMerchantSearch}
                  onChange={e => {
                    setPromoMerchantSearch(e.target.value);
                    searchMerchantsForPromo(e.target.value);
                  }}
                  placeholder="Search merchants by email..."
                />
                {promoSearchedMerchants.length > 0 && (
                  <div className="merchant-search-results compact">
                    {promoSearchedMerchants.map(m => (
                      <div
                        key={m.id}
                        className={`merchant-result-item ${promoForm.targetMerchantIds.includes(m.id) ? 'selected' : ''}`}
                        onClick={() => {
                          if (!promoForm.targetMerchantIds.includes(m.id)) {
                            setPromoForm(prev => ({
                              ...prev,
                              targetMerchantIds: [...prev.targetMerchantIds, m.id]
                            }));
                          }
                        }}
                      >
                        <div className="merchant-info">
                          <strong>{m.email}</strong>
                          <span>{m.merchantTier || 'FREE'}</span>
                        </div>
                        {promoForm.targetMerchantIds.includes(m.id) && <span className="selected-badge"><Icons.Check /> Selected</span>}
                      </div>
                    ))}
                  </div>
                )}
                {promoForm.targetMerchantIds.length > 0 && (
                  <div className="selected-merchants-list">
                    <small>Selected merchants ({promoForm.targetMerchantIds.length}):</small>
                    <div className="selected-tags">
                      {promoForm.targetMerchantIds.map(id => (
                        <span key={id} className="merchant-tag">
                          {id.substring(0, 8)}...
                          <button
                            type="button"
                            onClick={() => setPromoForm(prev => ({
                              ...prev,
                              targetMerchantIds: prev.targetMerchantIds.filter(mid => mid !== id)
                            }))}
                          >
                            ×
                          </button>
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                <small className="form-hint">Leave empty to allow all eligible merchants.</small>
              </div>

              {promoForm.isPrivate && promoForm.code && (
                <div className="form-row">
                  <label>Offer Link</label>
                  <div className="offer-link-preview">
                    <code>https://app.userevstar.com/offer?code={promoForm.code}</code>
                    <button
                      type="button"
                      className="btn-sm"
                      onClick={() => {
                        navigator.clipboard.writeText(`https://app.userevstar.com/offer?code=${promoForm.code}`);
                        showModal('success', 'Copied!', 'Offer link copied to clipboard');
                      }}
                    >
                      Copy
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="modal-btn modal-btn-secondary" onClick={() => setPromoForm(prev => ({ ...prev, isOpen: false }))}>Cancel</button>
              <button className="modal-btn modal-btn-primary" onClick={handleSavePromo} disabled={actionLoading === 'promo'}>
                {actionLoading === 'promo' ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Nudge Form Modal */}
      {nudgeForm.isOpen && (
        <div className="modal-overlay" onClick={() => setNudgeForm(prev => ({ ...prev, isOpen: false }))}>
          <div className="modal-content modal-form" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Send Nudge</h3>
              <button className="modal-close" onClick={() => setNudgeForm(prev => ({ ...prev, isOpen: false }))}><Icons.X /></button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <label>Target</label>
                <select value={nudgeForm.targetType} onChange={e => setNudgeForm(prev => ({ ...prev, targetType: e.target.value, userId: '' }))}>
                  <option value="single">Single Merchant</option>
                  <option value="bulk">Bulk (Group)</option>
                </select>
              </div>
              {nudgeForm.targetType === 'single' && (
                <>
                  <div className="form-row">
                    <label>Search Merchant</label>
                    <input
                      type="text"
                      value={merchantSearch}
                      onChange={e => setMerchantSearch(e.target.value)}
                      placeholder="Type to search by email or name..."
                    />
                  </div>
                  <div className="form-row">
                    <label>Select Merchant *</label>
                    <select
                      value={nudgeForm.userId}
                      onChange={e => setNudgeForm(prev => ({ ...prev, userId: e.target.value }))}
                    >
                      <option value="">-- Select a merchant --</option>
                      {merchants.map(m => (
                        <option key={m.id} value={m.id}>
                          {m.email} {m.username ? `(${m.username})` : ''} - {m.merchantTier || 'FREE'}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
              {nudgeForm.targetType === 'bulk' && (
                <div className="form-row">
                  <label>Target Group</label>
                  <select value={nudgeForm.targetGroup} onChange={e => setNudgeForm(prev => ({ ...prev, targetGroup: e.target.value }))}>
                    <option value="expiring_soon">Expiring Soon (7 days)</option>
                    <option value="expired">Recently Expired</option>
                    <option value="free_tier">All Free Tier</option>
                    <option value="inactive">Inactive (30+ days)</option>
                  </select>
                </div>
              )}
              <div className="form-row">
                <label>Nudge Type</label>
                <select value={nudgeForm.nudgeType} onChange={e => setNudgeForm(prev => ({ ...prev, nudgeType: e.target.value }))}>
                  <option value="RENEWAL_REMINDER">Renewal Reminder</option>
                  <option value="EXPIRED_FOLLOWUP">Expired Follow-up</option>
                  <option value="UPGRADE_OFFER">Upgrade Offer</option>
                  <option value="SPECIAL_OFFER">Special Offer</option>
                  <option value="WIN_BACK">Win Back</option>
                </select>
              </div>
              <div className="form-row">
                <label>Subject</label>
                <input type="text" value={nudgeForm.subject} onChange={e => setNudgeForm(prev => ({ ...prev, subject: e.target.value }))} placeholder="Email subject (optional)" />
              </div>
              <div className="form-row">
                <label>Message *</label>
                <textarea rows={4} value={nudgeForm.message} onChange={e => setNudgeForm(prev => ({ ...prev, message: e.target.value }))} placeholder="Your message to merchants..." />
              </div>
              <div className="form-row">
                <label>Include Promo Code (optional)</label>
                <select value={nudgeForm.includePromoCode} onChange={e => setNudgeForm(prev => ({ ...prev, includePromoCode: e.target.value }))}>
                  <option value="">No promo code</option>
                  {promos.filter(p => p.isActive && !p.isExpired).map(p => (
                    <option key={p.id} value={p.code}>{p.code} - {p.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-btn modal-btn-secondary" onClick={() => setNudgeForm(prev => ({ ...prev, isOpen: false }))}>Cancel</button>
              <button
                className="modal-btn modal-btn-primary"
                onClick={handleSendNudge}
                disabled={actionLoading === 'nudge' || !nudgeForm.message || (nudgeForm.targetType === 'single' && !nudgeForm.userId)}
              >
                {actionLoading === 'nudge' ? 'Sending...' : 'Send Nudge'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Trial Form Modal */}
      {trialForm.isOpen && (
        <div className="modal-overlay" onClick={() => setTrialForm(prev => ({ ...prev, isOpen: false }))}>
          <div className="modal-content modal-form" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Add Merchant to Free Trial</h3>
              <button className="modal-close" onClick={() => setTrialForm(prev => ({ ...prev, isOpen: false }))}><Icons.X /></button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <label>Search Merchant *</label>
                <input
                  type="text"
                  value={trialMerchantSearch}
                  onChange={(e) => {
                    setTrialMerchantSearch(e.target.value);
                    searchMerchantsForTrial(e.target.value);
                  }}
                  placeholder="Type email or username to search..."
                />
              </div>
              {searchedMerchants.length > 0 && (
                <div className="form-row">
                  <label>Select Merchant</label>
                  <div className="merchant-search-results">
                    {searchedMerchants.map(m => (
                      <div
                        key={m.id}
                        className={`merchant-result-item ${trialForm.userId === m.id ? 'selected' : ''} ${m.hasActiveTrial ? 'has-trial' : ''}`}
                        onClick={() => !m.hasActiveTrial && setTrialForm(prev => ({ ...prev, userId: m.id }))}
                      >
                        <div className="merchant-info">
                          <strong>{m.email}</strong>
                          <span>{m.storeName} • {m.currentTier}</span>
                        </div>
                        {m.hasActiveTrial && <span className="trial-badge">Has Active Trial</span>}
                        {trialForm.userId === m.id && <span className="selected-badge"><Icons.Check /> Selected</span>}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div className="form-row-inline">
                <div>
                  <label>Tier *</label>
                  <select value={trialForm.tierName} onChange={e => setTrialForm(prev => ({ ...prev, tierName: e.target.value }))}>
                    {tiers.filter(t => t.tier !== 'FREE').map(t => (
                      <option key={t.tier} value={t.tier}>{t.name || t.tier}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>Trial Days</label>
                  <input
                    type="number"
                    value={trialForm.trialDays}
                    onChange={e => setTrialForm(prev => ({ ...prev, trialDays: e.target.value }))}
                    min={1}
                    max={90}
                  />
                </div>
              </div>
              <div className="form-row">
                <label>Notes (optional)</label>
                <textarea
                  value={trialForm.notes}
                  onChange={e => setTrialForm(prev => ({ ...prev, notes: e.target.value }))}
                  placeholder="Internal notes about this trial..."
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-btn modal-btn-secondary" onClick={() => setTrialForm(prev => ({ ...prev, isOpen: false }))}>Cancel</button>
              <button
                className="modal-btn modal-btn-primary"
                onClick={handleAddTrial}
                disabled={actionLoading === 'trial' || !trialForm.userId}
              >
                {actionLoading === 'trial' ? 'Adding...' : 'Add to Trial'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Trial Settings Form Modal */}
      {trialSettingsForm.isOpen && (
        <div className="modal-overlay" onClick={() => setTrialSettingsForm(prev => ({ ...prev, isOpen: false }))}>
          <div className="modal-content modal-form" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{trialSettingsForm.tierName ? 'Edit' : 'Add'} Trial Settings</h3>
              <button className="modal-close" onClick={() => setTrialSettingsForm(prev => ({ ...prev, isOpen: false }))}><Icons.X /></button>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <label>Tier *</label>
                <select
                  value={trialSettingsForm.tierName}
                  onChange={e => setTrialSettingsForm(prev => ({ ...prev, tierName: e.target.value }))}
                  disabled={!!trialSettingsForm.tierName && trialSettings.some(s => s.tierName === trialSettingsForm.tierName)}
                >
                  <option value="">Select a tier...</option>
                  {tiers.filter(t => t.tier !== 'FREE').map(t => (
                    <option key={t.tier} value={t.tier}>{t.name || t.tier}</option>
                  ))}
                </select>
              </div>
              <div className="form-row-inline">
                <div>
                  <label>Trial Days *</label>
                  <input
                    type="number"
                    value={trialSettingsForm.trialDays}
                    onChange={e => setTrialSettingsForm(prev => ({ ...prev, trialDays: e.target.value }))}
                    min={1}
                    max={90}
                  />
                </div>
                <div>
                  <label>Max Trials per User</label>
                  <input
                    type="number"
                    value={trialSettingsForm.maxTrialsPerUser}
                    onChange={e => setTrialSettingsForm(prev => ({ ...prev, maxTrialsPerUser: e.target.value }))}
                    min={1}
                    max={10}
                  />
                </div>
              </div>
              <div className="form-row">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={trialSettingsForm.isEnabled}
                    onChange={e => setTrialSettingsForm(prev => ({ ...prev, isEnabled: e.target.checked }))}
                  />
                  Trial Enabled for this Tier
                </label>
              </div>
              <div className="form-row">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={trialSettingsForm.requiresCard}
                    onChange={e => setTrialSettingsForm(prev => ({ ...prev, requiresCard: e.target.checked }))}
                  />
                  Require Card on File (for future billing)
                </label>
              </div>
              <div className="form-row">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={trialSettingsForm.autoConvert}
                    onChange={e => setTrialSettingsForm(prev => ({ ...prev, autoConvert: e.target.checked }))}
                  />
                  Auto-convert to Paid when Trial Ends
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-btn modal-btn-secondary" onClick={() => setTrialSettingsForm(prev => ({ ...prev, isOpen: false }))}>Cancel</button>
              <button
                className="modal-btn modal-btn-primary"
                onClick={handleSaveTrialSettings}
                disabled={actionLoading === 'trialSettings' || !trialSettingsForm.tierName}
              >
                {actionLoading === 'trialSettings' ? 'Saving...' : 'Save Settings'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Generic Modal */}
      {modal.isOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className={`modal-content modal-${modal.type}`} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-icon">
                {modal.type === 'success' && <Icons.Check />}
                {modal.type === 'error' && <Icons.X />}
                {modal.type === 'warning' && '!'}
                {modal.type === 'confirm' && '?'}
                {modal.type === 'info' && 'i'}
              </div>
              <h3 className="modal-title">{modal.title}</h3>
              <button className="modal-close" onClick={closeModal}><Icons.X /></button>
            </div>
            <div className="modal-body">
              {modal.message && <p className="modal-message" style={{ whiteSpace: 'pre-line' }}>{modal.message}</p>}
              {modal.details && (
                <div className="modal-details">
                  {Object.entries(modal.details).map(([key, value]) => (
                    <div key={key} className="detail-row">
                      <span className="detail-label">{key}:</span>
                      <span className="detail-value">{value}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="modal-footer">
              {modal.onConfirm ? (
                <>
                  <button className="modal-btn modal-btn-secondary" onClick={closeModal}>Cancel</button>
                  <button className={`modal-btn modal-btn-primary modal-btn-${modal.type}`} onClick={modal.onConfirm}>
                    {modal.type === 'warning' ? 'Proceed' : 'Confirm'}
                  </button>
                </>
              ) : (
                <button className="modal-btn modal-btn-primary" onClick={closeModal}>Close</button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionManagement;
